import React from 'react'
import {connect} from 'react-redux'
import PropTypes from 'prop-types'

import {closeMobileMenu} from '../../actions/mobileMenu'
import * as mobileMenu from '../../store/mobileMenu'

import Overlay from '../Overlay'

const MobileMenuOverlay = (props) => (
  <Overlay
    className="mobile-menu-overlay"
    isVisible={props.isVisible}
    onClick={props.closeMobileMenu}
  />
)

MobileMenuOverlay.propTypes = {
  closeMobileMenu: PropTypes.func.isRequired,
  isVisible: PropTypes.bool.isRequired,
}

const mapStateToProps = (state) => ({isVisible: mobileMenu.isOpen(state)})
const mapDispatchToProps = (dispatch) => ({closeMobileMenu: () => dispatch(closeMobileMenu())})

export default connect(mapStateToProps, mapDispatchToProps)(MobileMenuOverlay)
